import { Browse } from 'spa/components/browse'
import { Layout, Sidebar } from 'spa/components/layout'
import React from 'react'
const SearchOverview = React.lazy(() => import('./search_overview'))
import { ModuleLoader } from '../module_loader/module_loader'

const display = () => {
  return (
    <Layout tabTitle="search-overview">
      <Sidebar>
        <Browse />
      </Sidebar>
      <ModuleLoader>
        <SearchOverview />
      </ModuleLoader>
    </Layout>
  )
}

export { display as SearchOverviewDisplay }

export { SearchOverview }

export default SearchOverview
